import AppRoutes from '../AppRoutes';
import { useNavigate } from 'react-router-dom';
import Login from '../components/Auth/Login';

function useLogin () {
    const navigate = useNavigate();

    const getLoginPath = () => {
        const component = <Login/>;
        const route = AppRoutes.find(route => route.element?.type?.name === component.type?.name);

        return route?.path;
    }

    const redirectToLogin = (callbackUrl, allowContinueWithoutAccount) => {
        const loginPath = getLoginPath();
        const allowWithoutAccount = allowContinueWithoutAccount === false ? false : true;

        if (loginPath) {
            callbackUrl
                ? navigate(loginPath, {state: {callbackUrl: callbackUrl, continueWithoutAccount: allowWithoutAccount}})
                : navigate(loginPath);
        }
    }

    return {
        redirectToLogin
    };
}

export default useLogin;
